import { ChangedHistoryModel } from './changed-history';
import { OrderComplainModel } from './order-complain';
import { PaymentHistoryModel } from './payment-history';
import { Product } from './product';

export class DepositModel {
    public createdBy!: any;
    public createdDate!: string;
    public shopDeliverDate!: string;
    public transactionCode!: string;
    public storeCNImDate!: string;
    public storeCNExDate!: string;
    public storeVNImDate!: string;
    public storeVNExDate!: string;
    public completedDate!: string;
    public curentCNYVN!: any;
    public exchangeRate!: any;
    public dathangID!: any;
    public depositCode!: string;
    public feeShipCN!: any;
    public feeShipVND!: any;
    public feeShipVN!: number;
    public totalOtherFee!: number;
    public weightPrice!: any;
    public weightPriceSnd!: any;
    public feeWeight!: any;
    public feeWeightCK!: any;
    public id!: number;
    public isChangeWeightByAdmin!: any;
    public isFeeShip!: any;
    public isCheck!: boolean;
    public isFragileGoods!: boolean;
    public isFoam!: boolean;
    public safeLevelID!: any;
    public safeLevelWeightAmount!: number;
    public safeLevelVolumeAmount!: number;
    public chinaStoreID!: any;
    public orderWeight!: number;
    public orderWeightRound!: number;
    public payment!: number;
    public guaranteeAmount!: number;
    public guaranteeAmountVND!: number;
    public surcharge!: number;
    public feeOther!: number;
    public feeOtherNote!: string;
    public fragileFee!: number;
    public fragileFeeVND!: number;
    public foamFee!: number;
    public foamFeeVND!: number;
    public checkFeeType!: number;
    public checkFee!: number;
    public checkFeeVND!: number;
    public receivePlaceID!: number;
    public salerID!: number;
    public status!: number;
    public statusDetail!: any;
    public totalPriceVND!: number;
    public discountVND!: number;
    public uId!: number;
    public updateDateWeightByAdmin!: any;
    public userName!: string;
    public feeShipType!: number;
    public priceType!: number;
    public voucherAmount!: number;
    public ProductAmount!: number;
    public ProductName!: string;
    public ProductImage!: string;
    public receivePlaceDetail!: any;
    public chinaStoreDetail!: any;
    
    public products!: Product[];
    public changedHistories!: ChangedHistoryModel[];
    public paymentHistory!: PaymentHistoryModel[];
    public orderComplains!: OrderComplainModel[];
};